module.exports = __webpack_public_path__ + "img/WAPPR_RED.da346061.svg";